<template>
    <div>
        {{prayer.prayer}} - <SingleElemDisplay :displayData="message"  @click="submitPrayer(prayer)" v-slot="{value}" class="prayerMessageTag">{{value}}</SingleElemDisplay>
    </div>
</template>

<script setup>
    import {defineProps, ref} from "vue";
    import prayerService from "@/services/prayerService";
    import SingleElemDisplay from "@/components/genericDisplay/SingleElemDisplay.vue";

    const props = defineProps(["prayer"]);
    const denySubmit = ref(props.prayer.prayedFor);
    const prayerThanks = "Thank you for praying for me :)";
    const prayerDone = "Somebody already prayed for me.";
    const prayerClickMessage = "Click here if you prayed for me.";
    const message = ref(props.prayer.prayedFor ? prayerDone : prayerClickMessage);

    function submitPrayer(prayer){
        if(!denySubmit.value){
            prayerService.setPrayer(prayer.wallId, prayer.prayerId).then(success => {
                if(success){
                    message.value = prayerThanks;
                    denySubmit.value = true;
                }
            });
        }
    }


</script>

<style scoped>
    .prayerMessageTag{
        white-space: nowrap;
        font-weight: 400;
        color: #757474;
        font-size: 14px;
        line-height: 1.6;
        letter-spacing: 0px;
    }
</style>